import { v4 as uuidv4 } from 'uuid';

const UidGenerator = {
  generate() {
    return uuidv4();
  },
};

export default UidGenerator;
